<template>
  <div style="position: relative;">
    <div class="product_mobile banner-bg">
      <div class="banner-container ">
        <div class="banner-title banner-center animate__zoomInDown">SmallStep</div>
        <div class="banner-content banner-center animate__zoomIn">
          {{ $t('subTitle') }}
        </div>
      </div>
    </div>
    <div class="companyIntroduction pathContainer">
      <div class="small-block-introduction bg-block"></div>
      <div class="big-block-introduction bg-block"></div>
      <div id="AboutUs" class="head-label">
        <!-- 公司简介 -->
        {{ $t('mode1') }}
      </div>
      <div class="flex w-3/5 mx-auto">
        <div>
          <div class="company-introduction content-card text1" style="padding-top: 0px;">
            {{ $t('p1') }}
          </div>
          <div class="company-introduction content-card text1">
            {{ $t('p2') }}
          </div>
        </div>
      </div>
    </div>

    <div class="pt-14">
      <div id="Products" class="head-label">
        {{ $t('mode2') }}
      </div>

      <img class="product-test" src="../assets/smallStep/product.jpg">

      <!-- <div class="productContainer flex-x-center items-start pt-20 pb-20" style="position: relative;">
        <div class="product-left mr-14">
          <img src="../assets/productIcon/vertical.jpg" alt="" class="mr-6 w-64 product-img"
            style="border-radius: 20px;">
        </div>
        <div class="product-right mt-20">
          <div class="product-head flex-center">
            <img src="../assets/productIcon/p1.jpg" alt="" class="product-icon" />
            <div class="border_title text-4xl text-center font-bold">Screw Puzzle Blast</div>
          </div>
          <div class="product-desc-wrap flex-center mt-20">
            <div class="text-2xl product-desc">An exciting puzzle game that redefines the way<br> players engage with
              challenging brain
              teasers</div>
          </div>
        </div>
      </div> -->
    </div>

    <div class="contactContainer">
      <div class="innerContactContainer">
        <div id="ContactUs" class="head-label" style="margin-bottom: 40px;">
          <!-- 联系我们 -->
          {{ $t('mode4') }}
        </div>

        <div class="flex flex-col w-11/12 mx-auto">
          <div class="con-wrap">
            <div class="con-title">
              <!-- 公司地址 -->
              {{ $t('usTitle1') }}
            </div>
            <div class="con-content">
              <!-- 广东省广州市海珠区昌岗街道达镖国际中心1908 -->
              {{ $t('usDesc1Line1') }}
              <br>
              {{ $t('usDesc1Line2') }}
              <br>
              {{ $t('usDesc1Line3') }}
            </div>
          </div>
          <div class="con-wrap">
            <div class="con-title">
              <!-- 加入我们 -->
              {{ $t('usTitle3') }}
            </div>
            <div class="con-content">
              {{ $t('usDesc3') }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 100%;margin: 20px auto; position: absolute; bottom: 40px; z-index: 999;">
      <div class="mx-auto text-center footer"><a href="http://beian.miit.gov.cn" target="_blank" style="color:#000">
          {{ $t('beian1') }}</a>
      </div>
    </div>

    <div class="bottom-info">
      <a class="mr-4 text-blue-300" href="/policy.html" target="_blank">{{ $t('policy') }}</a>
      <a class="text-blue-300" href="/service.html" target="_blank">{{ $t('service') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fixed: false,
      iconList: [
        { iconUrl: require('../assets/productIcon/p1.jpg'), gameName: 'Screw Puzzle Blast' }
      ]
    };
  },
  methods: {
    handleScroll() {
      // 获取高度
      let banner = document.getElementsByClassName('banner-bg')[0];
      let header = document.getElementsByClassName('header')[0];
      let bannerOffSetTop = banner.offsetTop;
      let bannnerOffSetHeight = banner.offsetHeight;
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset || 0;
      if (scrollTop < bannerOffSetTop + bannnerOffSetHeight) {
        this.fixed = false;
        if (!header.classList.contains('showTopMenu')) {
          header.classList += ' showTopMenu';
          header.classList.remove('hideTopMenu');
        }
      } else {
        if (header.classList.contains('showTopMenu')) {
          header.classList.remove('showTopMenu');
          header.classList += ' hideTopMenu';
        }
        this.fixed = true;
      }
    }
  }
};
</script>

<style lang="css" scoped>
@import '../assets/css/main.css';

.pathContainer {
  overflow: hidden;
}

.companyIntroduction {
  position: relative;
  overflow: hidden;
}

.bg-block {
  position: absolute;
  background-size: cover;
}


.small-block-introduction {
  background-image: url('../assets/smallStep/官网_slices/矩形8拷贝4.png');
  width: 64px;
  height: 64px;
  top: 20px;
  left: 84%;
}

.big-block-introduction {
  background-image: url('../assets/smallStep/官网_slices/矩形8.png');
  width: 328.5px;
  height: 328.5px;
  left: 87%;
  top: 73px;
}

.big-block-advantage {
  background: url('../assets/smallStep/官网_slices/矩形8拷贝.png') no-repeat center;
  background-size: contain;
  width: 328.5px;
  height: 328.5px;
  top: 75%;
  left: -8%;
}

.product-test {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  display: inline-block;
  width: 920px;
  border-radius: 20px;
  margin-bottom: 100px;
}


.productContainer {
  width: 80%;
  background-color: #F3F5F7;
  border-radius: 57px;
  margin: 0 auto;
}

.product-icon {
  overflow: hidden;
  width: 5em;
  margin-right: 30px;
  border-radius: 20%;
}

.product_mobile_content {
  width: 100%;
  margin-top: 15px;
}

.product_mobile {
  align-items: center;
}

.banner-bg {
  background-image: url('../assets/smallStep/官网_slices-1/topBanner.png');
  background-size: 100% 100%;
  background-position: center;
  width: 100%;
  height: 663px;
  background-repeat: no-repeat;
  position: relative;
  color: #fff;
}

.banner-bg .banner-container {
  width: 80%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.banner-title {
  font-size: 5em;
  font-weight: 500;
  margin-bottom: 1em;
}

.banner-center {
  text-align: center;
}

.banner-content {
  font-size: 1.5rem;
  font-weight: 400;
  margin-top: 1em;
}

.head-label {
  position: relative;
  font-size: 2.5em;
  text-align: center;
  padding-top: 67px;
  font-weight: bold;
  margin-bottom: 80px;
}

.content-card {
  padding-top: 30px;
}

.text1 {
  font-size: 28px;
  line-height: 48px;
  font-family: PingFangSC-Regular, PingFang SC, "Gill Sans", sans-serif;
  font-weight: 400;
  color: #000;
}

.advantage-parent {
  display: flex;
}

.advantage-img-parent {
  text-align: center;
}

.advantage-img {
  box-shadow: 0 12px 12px 0 rgb(0 0 0 / 20%);
  width: 186.5px;
  height: 132.5px;
  border-radius: 18px;
}

.advantage-title {
  margin-top: 25px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;

}

.border_parent {
  width: 90%;
  margin: auto;
}

.border {
  border-radius: 6px;
  border: 1px solid #EBEEF5;
  height: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding-bottom: 25px;
}

.border_img_parent {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.border_content_one {
  margin-top: 20px;
  font-size: 1em;
  color: #666;
  text-align: center;
  text-shadow: rgb(68, 68, 68);
}

.border_content_two {
  margin-top: 5px;
  font-size: 1.125em;
  margin-bottom: 25px;
  text-align: center;
}

.img_border {
  margin-top: 15px;
  width: 80px;
  height: 80px
}

.benefit-parent {
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 62%;
  margin: 112.25px auto;
}

.benefit-wrap {
  width: 33.3%;
}

.iconListGameName {
  font-size: 1.5em;
  width: 80%;
  margin: 1em 0;
  color: rgba(0, 0, 0, );
  font-weight: bold;
}

.text_bottom_shadow {
  position: relative;
}

.text_bottom_shadow::after {
  content: "";
  width: 98%;
  height: 0.23em;
  background: rgba(136, 136, 136, 0.233);
  position: absolute;
  border-radius: 25%;
  top: 86%;
  left: 50%;
  transform: translate(-50%, -50%);

}

.contactContainer {
  position: relative;
  width: 100%;
  height: auto;
  background-image: url('../assets/smallStep/官网_slices/组\ 307.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center 50px;
  padding: 90px 0px 130px 0px;
}


.contactContainer .innerContactContainer {
  width: 62%;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 20px;
  padding-bottom: 20px;
}

.con-title {
  font-size: 1.5em;
  color: #222;
  font-weight: 600;
  margin-bottom: 1em;
  text-align: center;
}


.con-content {
  margin-bottom: 25px;
  text-align: center;
  line-height: 2em;
}


.showTopMenu {
  opacity: 255;
  transition: opacity 1s ease-in-out;
}

.hideTopMenu {
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.footer {
  font-size: 0.8em;
  text-align: center;
  justify-content: space-between;
}

.bottom-info {
  position: absolute;
  bottom: 20px;
  z-index: 999;
  display: flex;
  left: 50%;
  transform: translateX(-50%);
  justify-content: center;
  font-size: 14px;
  text-wrap: nowrap;
}
</style>

<style scoped>
/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
  .advantage-parent {
    flex-direction: column;
  }

  .advantage-img-parent-wrap {
    width: 100%;
    margin-bottom: 30px;
  }

  .banner-title {
    font-size: 2em;
  }

  .banner-content {
    font-size: 1em;
  }

  .head-label h2 {
    position: relative;
    font-size: 1.2em;
    margin: 0.5em 0;
  }

  .benefit-parent {
    flex-direction: column;
    align-items: center;
    margin-top: 0px;
    width: 82%;
  }

  .product-test {
    width: 90%;
  }

  .product-desc-wrap {
    flex-direction: column;
    align-items: center;
    margin-top: 80px;
  }

  .product-img {
    width: 300px;
    margin-right: 0;
    margin-bottom: 30px;
  }

  .product-desc {
    text-align: center;
  }

  .product-left {
    display: none;
  }

  .product-right {
    margin-top: 0;
  }

  .benefit-wrap {
    width: 100%;
    margin-bottom: 20px;
  }

  .company-introduction {
    font-size: 1em;
    line-height: 1.5em;
    padding-top: 15px;
  }

  .border_parent {
    display: flex;
    width: 90%;
    margin: auto;
    height: auto;
    flex-direction: column;
  }

  .border {
    border-radius: 6px;
    border: 1px solid #ebeef5;
    float: left;
    width: 100%;
    height: auto;
    margin: 10px 0 auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .border_img_parent {
    margin-top: 0;
  }

  .border_title {
    margin-left: 10px;
    font-family: 'PingFang SC';
    font-size: 1em;
    font-weight: 600;
  }

  .border_content_one {
    position: relative;
    margin-top: 20px;
    font-size: 0.8em;
    height: 2em;
    line-height: 2em;
  }

  .text_bottom_shadow::after {
    display: none;
  }

  .border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 8px;
  }

  .img_border {
    margin-top: 8px;
    width: 80px;
    height: 80px;
  }

  .contactContainer {
    background-size: cover;
    padding-bottom: 200px;
  }

  .innerContactContainer {
    width: 90% !important;
  }

  .product-icon {
    width: 5em;
    margin-right: 0;
  }

  .iconListGameName {
    font-size: 0.85em;
    width: 80%;
  }

  .product_mobile {
    align-items: center;
    height: auto;
  }

  .product_mobile_content {
    width: 100%;
    margin-top: 15px;
  }

  .banner-bg {
    height: 250px;
    width: 100%;
    background-size: 100% 100%;
    background-position: 50%;
  }

  .con-wrap {
    width: 100%;
  }

  .con-title {
    font-size: 1.25em;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px auto;
    color: #222;
    font-size: 0.88em;
  }

  .footer span {
    text-align: center;
  }

  .footer span a {
    display: inline-block;
  }
}
</style>
